import { dataKeyboard } from 'dls-icons-data'
import { createIcon } from '../common'

const IconKeyboard = /*#__PURE__*/createIcon(dataKeyboard)
export default IconKeyboard
